<template>
  <div class="px-6 sm:px-8 relative" ref="rootEl">
    <RouterLink
      class="py-12 block mx-auto max-w-4xl w-full group"
      :class="{ 'border-b border-black': showBorder }"
      :to="to"
      @click="onClick"
    >
      <div class="mb-4 md:mb-0 md:absolute left-8 top-12">{{ dateStr }}</div>

      <div
        class="max-w-lg mx-auto text-center text-2xl md:text-3xl whitespace-pre-line"
      >
        {{ titleTop }}
      </div>
      <div class="max-w-lg mx-auto">
        <div class="w-36 md:w-96 mx-auto my-8">
          <img
            :srcset="hero.mobile.srcset"
            :src="hero.mobile.src"
            class="block md:hidden"
          />
          <img
            :srcset="hero.desktop.srcset"
            :src="hero.desktop.src"
            class="hidden md:block"
          />
        </div>
      </div>
      <div class="relative">
        <span
          class="link-dot-absolute w-2.5 sm:w-3 h-2.5 sm:h-3 top-2.5 left-2"
        />
        <div
          class="max-w-lg mx-auto text-center text-2xl md:text-3xl font-serif whitespace-pre-line"
        >
          {{ titleBottom }}
        </div>
      </div>
    </RouterLink>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, VNode, watch } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import { StoryPoster } from '@/types';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    to: {
      type: Object as PropType<RouteLocationRaw>,
      required: true,
    },
    hero: {
      type: Object as PropType<StoryPoster>,
      required: true,
    },
    titleTop: {
      type: String,
      required: true,
    },
    titleBottom: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['activate', 'animated'],
  setup(props, { emit }) {
    const date = new Date(props.date);
    const dateStr = `${date.toLocaleString('en-GB', {
      month: 'long',
    })} ${date.getFullYear()}`;

    const rootEl = ref<VNode | null>(null);
    const onClick = (e: Event) => {
      e.preventDefault();
      if (rootEl.value) {
        emit('activate', rootEl.value);
      }
    };

    const onActivate = () => {
      setTimeout(() => {
        emit('animated');
      }, 700);
    };
    watch(() => props.active, onActivate);

    return {
      dateStr,
      onClick,
      rootEl,
    };
  },
});
</script>
